var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{class:['app-avatar', 'text-xs-center'],attrs:{"title":_vm.$lang.home,"aspect-ratio":16/9,"src":_vm.backgroundImage},on:{"click":function($event){return _vm.$router.push({path: _vm.to})}}},[_c('v-icon',{class:['mt-3', 'item-clickable'],attrs:{"color":_vm.iconColor,"size":(_vm.iconSize + "em")}},[_vm._v(_vm._s(_vm.icon))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73594246","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-avatar.vue
// module id = null
// module chunks = 